import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { getFeaturedMovies } from '@/mocks/movies';

export default function FeaturedSection() {
  const featured = getFeaturedMovies();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">高分佳作，值得一看</p>
          </div>
          <Link
            to="/category/juqing"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((movie) => (
            <MovieCard key={movie.id} movie={movie} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}